export default {
    section: 'Business Formation Information',
    name: 'equity-appreciation-business-information',
    questionWidth: 4,
    items: [
        {
            type: 'text-field',
            text: 'Business Name',
            name: 'employee-owner-business-name',
            props: {
                label: 'Business Name',
                tooltip: 'Full Legal Name'
            }
        },
        {
            type: 'selectlist',
            text: 'State of Formation',
            name: 'employee-owner-state-formation',
            width: 3,
            props: {
                items: [
                    // TODO: SWAP STATES
                    {
                        text: 'swap-states',
                        value: 'swap-states'
                    }
                ]
            }
        },
        {
            type: 'datepicker',
            text: 'Date of Formation',
            name: 'employee-owner-date-formation',
            width: 3,
            props: {
                label: 'Date of Formation'
            }
        },
        {
            type: 'text-field',
            text: 'Legal Address',
            name: 'employee-owner-address-street',
            props: {
                label: 'Address'
            },
            subItems: [
                {
                    type: 'inline',
                    text: ' ',
                    items: [
                        {
                            type: 'text-field',
                            name: 'employee-owner-address-city',
                            width: 3,
                            props: {
                                label: 'City'
                            }
                        },
                        {
                            type: 'selectlist',
                            name: 'employee-owner-address-state',
                            width: 1,
                            props: {
                                label: 'State',
                                items: [
                                    // TODO: Swap States
                                    {
                                        text: 'swap-states',
                                        value: 'swap-states'
                                    }
                                ]
                            }
                        },
                        {
                            type: 'text-field',
                            name: 'employee-owner-address-zip',
                            width: 2,
                            props: {
                                label: 'Zip'
                            }
                        }
                    ]
                }
            ]
        },
        {
            type: 'text-field',
            text: 'County of Legal Address',
            name: 'employee-owner-county',
            props: {
                label: 'County of Legal Address'
            }
        },
        {
            type: 'selectlist',
            text: 'Entity Type',
            name: 'employee-owner-entity-type',
            props: {
                items: [
                    // TODO: SWAP ENTITY TYPES
                    {
                        text: 'swap-entity-type',
                        value: 'swap-entity-type'
                    }
                ]
            },
            subItems: [
                {
                    type: 'radio-list',
                    text: 'Subchapter S Election',
                    name: 'employee-owner-subchapter-s',
                    props: {
                        row: true,
                        items: [
                            {
                                text: 'Yes',
                                value: 'yes'
                            },
                            {
                                text: 'No',
                                value: 'no'
                            }
                        ]
                    }
                }
            ]
        },
        {
            type: 'text-field',
            text: 'Number of Authorized Units/Shares',
            name: 'employee-owner-authorized-units',
            width: 3,
            props: {
                label: 'Authorized Units/Shares',
                format: 'number'
            }
        },
        {
            type: 'text-field',
            text: 'Number of Issued Units/Shares',
            name: 'employee-owner-issued-units',
            width: 3,
            props: {
                label: 'Issued Units/Shares',
                format: 'number'
            }
        },
        {
            type: 'text-field',
            text: 'Current Value per Unit/Share',
            name: 'equity-appreciatin-value-share',
            width: 3,
            props: {
                label: 'Current Value',
                format: 'dollars'
            }
        },
        {
            type: 'datepicker',
            text: 'Date of Last Valuation',
            name: 'equity-appreciation-last-valuation',
            width: 3,
            props: {
                label: 'Date of Last Valuation'
            }
        },
        {
            type: 'data-table',
            name: 'equity-appreciation-owners',
            props: {
                headers: [
                    {
                        text: 'Name',
                        value: 'full-name'
                    },
                    {
                        text: 'Title',
                        value: 'title'
                    },
                    {
                        // TODO: Verify that this is a percentage
                        text: 'Ownership Interest',
                        value: 'ownership-interest',
                        format: 'percent'
                    }
                ],
                newItemLabel: 'Add New Owner',
                noDataLabel: 'Please Add an Owner'
            }
        }
    ]
};


// WEBPACK FOOTER //
// ./src/components/equity-appreciation/valuation-data/business-information.js